import script from "./StopPanelDestination.vue?vue&type=script&setup=true&lang=js"
export * from "./StopPanelDestination.vue?vue&type=script&setup=true&lang=js"

import "./StopPanelDestination.vue?vue&type=style&index=0&id=231f8243&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-231f8243"]])

export default __exports__